import { GROUPS, REDIRECT_URLS } from "../../globalConstants";
import { inject } from "../../lib/itn-ui-kit/services/service-container";

export default class LandingService {
  currentUserService = inject("current-user-service");

  get accessibleRoutes() {
    return this.currentUserService.accessibleRoutes || [];
  }

  get defaultDashboardRoute() {
    const routes = this.currentUserService.user.route_map || [];
    const defaultRouteId = routes[0]?.id || "";
    return defaultRouteId ? `/dashboard/${defaultRouteId}` : "/search";
  }

  resolveRouteUrl(routeKey) {
    switch (routeKey) {
      case GROUPS.FINANCE:
        return REDIRECT_URLS.FINANCE;
      case GROUPS.MEDICAL_RECORDS:
        return REDIRECT_URLS.MEDICAL_RECORDS;
      // case GROUPS.MCC:
      // case GROUPS.DATA_ENTRY:
      //   return this.defaultDashboardRoute;
      default:
        return REDIRECT_URLS.DASHBOARD;
    }
  }

  get PriorityAccessibleKey() {
    const accessibleRoutes = this.accessibleRoutes;

    if (accessibleRoutes.includes(GROUPS.FINANCE)) {
      return GROUPS.FINANCE;
    } else if (accessibleRoutes.includes(GROUPS.MEDICAL_RECORDS)) {
      return GROUPS.MEDICAL_RECORDS;
    }
    // else if (
    //   accessibleRoutes.includes(GROUPS.MCC) ||
    //   accessibleRoutes.includes(GROUPS.DATA_ENTRY)
    // ) {
    //   return DASHBOARD_KEYS.dashboardId;
    // }
    else {
      return "dashboard";
    }
  }

  get PriorityAccessibleRoute() {
    //returns string route of first match which right now is finance
    const accessibleRoutes = this.accessibleRoutes;

    if (accessibleRoutes.includes(GROUPS.FINANCE)) {
      return REDIRECT_URLS.FINANCE;
    } else if (accessibleRoutes.includes(GROUPS.MEDICAL_RECORDS)) {
      return REDIRECT_URLS.MEDICAL_RECORDS;
    }
    // else if (accessibleRoutes.includes(GROUPS.MCC)) {
    //   return this.defaultDashboardRoute;
    // } else if (accessibleRoutes.includes(GROUPS.DATA_ENTRY)) {
    //   return this.defaultDashboardRoute;
    // }
    else {
      return REDIRECT_URLS.DASHBOARD;
    }
  }

  get AllAccessibleRoutes() {
    //returns list of all accessible routes
    if (this.accessibleRoutes.length === 0) {
      //if you have no special routes show the main dashboard
      return [{ name: "", url: REDIRECT_URLS.DASHBOARD }];
    }

    return this.accessibleRoutes.map((routeKey) => ({
      name: routeKey,
      url: this.resolveRouteUrl(routeKey),
    }));
  }
}
